import bronzeMedalGif from '../img/bronze-medal.gif'
import bronzeMedalWebp from '../img/bronze-medal.webp'
import globeGif from '../img/globe.gif'
import globeWebp from '../img/globe.webp'
import goldMedalGif from '../img/gold-medal.gif'
import goldMedalWebp from '../img/gold-medal.webp'
import silverMedalGif from '../img/silver-medal.gif'
import silverMedalWebp from '../img/silver-medal.webp'

type PerformanceIcon = {
	gif: string
	webp: string
	alt: string
	rank: 'gold' | 'silver' | 'bronze' | 'default'
}

// gold / silver / bronze medals for the top 3 buckets, planet for everything else
const MEDAL_ICONS: Record<number, PerformanceIcon> = {
	1: {
		gif: goldMedalGif,
		webp: goldMedalWebp,
		alt: '🥇',
		rank: 'gold',
	},
	2: {
		gif: silverMedalGif,
		webp: silverMedalWebp,
		alt: '🥈',
		rank: 'silver',
	},
	3: {
		gif: bronzeMedalGif,
		webp: bronzeMedalWebp,
		alt: '🥉',
		rank: 'bronze',
	},
}
const PLANET_ICON: PerformanceIcon = {
	gif: globeGif,
	webp: globeWebp,
	alt: '🌍',
	rank: 'default',
}

export default function getPerformanceIcon(performance: string): PerformanceIcon {
	const bucket = Number(performance.match(/\d+/)?.[0])
	return MEDAL_ICONS[bucket] || PLANET_ICON
}
